import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import Feed from "./components/Feed.js";
import Post from "./components/Post.js";
import LoginPage from "./components/LoginPage.js";
import NotFound from "./components/NotFound.js";
import Home from "./components/Home.js";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSignedIn: false,
    };
  }

  // method for setting signed in state, called from Login on successful auth
  setLogin = () => {
    console.log("logging in from App");
    this.setState({ isSignedIn: true });
  };

  setLogout = () => {
    console.log("logging out from App");
    this.setState({ isSignedIn: false });
  };

  setFalse = () => {
    console.log("logging out from App");
    this.setState({ isSignedIn: false });
    window.alert("You aint my baby. Begone.");
  };


  render() {
    if (!this.state.isSignedIn) {
      return (
        <LoginPage
          setLogin={this.setLogin}
          setLogout={this.setLogout}
          setFalse={this.setFalse}
          isSignedIn={this.state.isSignedIn}
          buttonLabel={"Hell yeah, I'm your baby!"}
        />
      );
    } else {
      return (
        <BrowserRouter>
          <Switch>
            <Route component={Home} path="/" exact />
            <Route component={Post} path="/:slug" />
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      );
    }
  }
}

export default App;
